import {
  Box,
  Breadcrumbs,
  Button,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ProfilePic from "../../../assests/profile.jpg";
import { Card } from "../../ui/Card";

const Kyc = () => {
  return (
    <>
      <Box
        sx={{
          marginBottom: "20px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/settings">
            <Typography color="text.primary" fontWeight={600}>
              Settings
            </Typography>
          </Link>
          <Typography color="text.primary">Company</Typography>
          <Typography color="text.primary">Kyc</Typography>
        </Breadcrumbs>
      </Box>
      <Card>
        {/* <Kyccard> */}
        <Grid container spacing={"200px"}>
          <Grid item xs={2}>
            <div>
              <img
                width={"200px"}
                height={"200px"}
                src={ProfilePic}
                alt=""
                draggable={false}
              />
            </div>
          </Grid>
          <Grid item xs={10}>
            <Box borderBottom="1px solid black" pb={2} mb={3}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize={13}>
                  KYC Status: <span style={{ color: "green" }}>Verified</span>
                </Typography>
                <Typography fontSize={13}>
                  Verified on: <span>Nov 7, 2023</span>
                </Typography>
                <Typography fontSize={13}>
                  Current business type: <span>Individual</span>
                </Typography>
              </Stack>
            </Box>

            <Box mb={3}>
              <Typography fontSize={13}>
                Verification method used: <span>Express KYC</span>
              </Typography>
            </Box>

            <Box
              width={300}
              mb={3}
              p={3}
              sx={{
                backgroundColor: "#f5f7fa",
                borderRadius: "8px",
              }}
            >
              <Typography fontSize={13}>
                Document 1 type : <span>Aadhaar Card</span>
              </Typography>
              <Typography fontSize={13}>
                Document 1 Number : <span>**********</span>
              </Typography>
            </Box>
          </Grid>
        </Grid>
        {/* </Kyccard> */}
        <Kyccard style={{ marginTop: "11px" }}>
          <Typography fontSize={13}>
            Upgraded your business type? Do KYC as a Sole Proprietor or Company by
            clicking upgrade your KYC.
          </Typography>

          <Button
            type="submit"
            variant="contained"
            sx={{
              mt: 3,
              background: "rgb(55, 188, 155)",
              borderRadius: "10px",
            }}
          >
            Upgrade Your KYC
          </Button>
        </Kyccard>
      </Card>

    </>
  );
};

const Kyccard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.05);
  min-height: auto;
  width: 80%;
  margin: auto;
`;

export default Kyc;
